<button
  pButton
  [rounded]="true"
  icon="fas fa-note-sticky"
  [label]="bookmark.title"
  [routerLink]="['ansicht', bookmark._id]"></button>
